'use client'

import { useState, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { getFaviconForProperty } from '@/utils/multiPropertyFavicon';

const DynamicFavicon = () => {
  const searchParams = useSearchParams();
  const [faviconFile, setFaviconFile] = useState('favicon.ico'); // Default favicon

  useEffect(() => {
    // This effect runs on the client side after hydration
    const propertyFromUrl = searchParams.get('property');
    let finalPropertyCode = null;

    if (propertyFromUrl) {
      // 1. Priority: Use property from URL
      finalPropertyCode = propertyFromUrl;
      // Save it to localStorage for future visits
      try {
        localStorage.setItem('lastFaviconProperty', propertyFromUrl);
      } catch (e) {
        console.warn('Could not save property to localStorage', e);
      }
    } else {
      // 2. Fallback: Use property from localStorage if URL has no property
      try {
        finalPropertyCode = localStorage.getItem('lastFaviconProperty');
      } catch (e) {
        console.warn('Could not read property from localStorage', e);
      }
    }

    // Set the favicon file based on the determined property code
    setFaviconFile(getFaviconForProperty(finalPropertyCode));

  }, [searchParams]); // Rerun when URL params change

  return (
    <link 
      rel="icon" 
      href={`/${faviconFile}?v=${new Date().getTime()}`} 
    />
  );
};

export default DynamicFavicon;
